<template>
  <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="formattedDate"
          label="时间段"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="dates" first-day-of-week="1" locale="zh-cn" range no-title>
      <v-btn text @click="menu = false">取消</v-btn>
      <v-spacer/>
      <v-btn text color="primary" @click="pickerThisWeek">这周</v-btn>
      <v-btn text color="primary" @click="pickerThisMonth">这个月</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek"

export default {
  name: "DateRangePicker",
  model: {
    prop: "dateModel",
    event: "update"
  },
  props: {
    dateModel: null
  },
  computed: {
    formattedDate() {
      return this.dates.join(" ~ ")
    },
    dates: {
      get() {
        return this.dateModel
      },
      set(val) {
        this.$emit("update", val)
      }
    }
  },
  data() {
    return {
      menu: null
    }
  },
  methods: {
    pickerThisWeek() {
      dayjs.extend(isoWeek);
      this.dates = [
        dayjs().startOf("isoWeek").format("YYYY-MM-DD"),
        dayjs().format("YYYY-MM-DD")];
      this.menu = false
    },
    pickerThisMonth() {
      this.dates = [
        dayjs().startOf("month").format("YYYY-MM-DD"),
        dayjs().format("YYYY-MM-DD")];
      this.menu = false
    },
  }
}
</script>

<style scoped>

</style>